import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useScrollAnimation = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const selector = ".anim-up, .anim-left, .anim-right, .anim-down, .anim-scale";
    const observed = new WeakSet<Element>();

    const revealIfInViewport = (el: HTMLElement) => {
      const rect = el.getBoundingClientRect();
      const viewH = window.innerHeight || document.documentElement.clientHeight;
      if (rect.top <= viewH * 0.96 && rect.bottom >= 0) {
        el.classList.add("anim-in");
      }
    };

    const animatedEls = Array.from(
      document.querySelectorAll<HTMLElement>(selector)
    );

    // Route degistiginde animasyonlarin tekrar calismasi icin sinifi sifirla.
    animatedEls.forEach((el) => el.classList.remove("anim-in"));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("anim-in");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -5% 0px" }
    );

    const observeElement = (el: HTMLElement) => {
      if (observed.has(el)) return;
      observed.add(el);
      revealIfInViewport(el);
      if (!el.classList.contains("anim-in")) {
        observer.observe(el);
      }
    };

    animatedEls.forEach(observeElement);

    // Observer bazi gecislerde kacirirsa icerik gizli kalmasin.
    const failSafeTimer = window.setTimeout(() => {
      document.querySelectorAll<HTMLElement>(selector).forEach((el) => {
        el.classList.add("anim-in");
      });
    }, 1200);

    // Sayfa gecisi sonrasi gec gelen node'lari da izle.
    const mutationObserver = new MutationObserver(() => {
      document
        .querySelectorAll<HTMLElement>(selector)
        .forEach(observeElement);
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.clearTimeout(failSafeTimer);
      mutationObserver.disconnect();
      observer.disconnect();
    };
  }, [pathname]);
};

export default useScrollAnimation;